import { productService } from '../_services';
import {
  PAYMENT_ITEM_ID,
  pickPaymentItemQty,
} from '../constants/paymentItemIds';

/**
 * 拉取账号支付项配额（含产品/公司媒体 RID 7–10）
 * @param {number} companyId
 * @returns {Promise<Array>}
 */
export async function fetchAccountPaymentItems(companyId) {
  if (!companyId) return [];
  const res = await productService.getSysAccountPaymentInfo({
    CompanyId: companyId,
    demodate: '',
  });
  if (!res || res.isSuccessful === false) return [];
  return Array.isArray(res.data) ? res.data : [];
}

/**
 * @param {object} opts
 * @param {number} opts.companyId
 * @param {number} opts.paymentItemId
 * @returns {Promise<number|null>} 未命中返回 null
 */
export async function resolveMediaQuota({ companyId, paymentItemId }) {
  try {
    const rows = await fetchAccountPaymentItems(companyId);
    return pickPaymentItemQty(rows, paymentItemId);
  } catch (e) {
    return null;
  }
}

export { PAYMENT_ITEM_ID, pickPaymentItemQty };
